import React from "react";
import { Link } from "react-router-dom";
import { Item } from '@atlaskit/navigation-next';

import HomeView from 'views/Home';
import SearchView from 'views/Search';
import StarredView from 'views/Starred';
import RecentlyDeletedView from 'views/RecentlyDeleted';
import PreviewView from 'views/ViewFile';
import SettingsView from 'views/Settings';

import './index.css';


function ParentComponent(props) {
  return (
    <div
      style={{
        flex: 1,
        height: '100%',
        width: '100%'
      }}
    >
      {props.children}
    </div>
  )
}

function renderLink(activeIndex, index, link, text, props = {}) {
  const isActive = activeIndex !== index;
  return (
    <Link
      {...props}
      to={link}
    >
      {text}
    </Link>
  )
}


export const renderSidebar = (activeIndex) => () => (
  <div>
    <Item component={ (props) => {
      return (renderLink(activeIndex, 1, '/dashboard', 'Dashboard', props));
    }}/>
    <Item component={ (props) => {
      return (renderLink(activeIndex, 2, '/starred', 'Starred files', props));
    }}/>
    <Item component={ (props) => {
      return (renderLink(activeIndex, 4, '/recently-deleted', 'Recently deleted', props));
    }}/>
  </div>
);

function Dashboard(props) {
  return (
    <ParentComponent>
      <HomeView {...props}/>
    </ParentComponent>
  )
}

function Search(props) {
  return (
    <ParentComponent>
      <SearchView {...props}/>
    </ParentComponent>
  )
}

function Starred(props) {
  return (
    <ParentComponent>
      <StarredView {...props}/>
    </ParentComponent>
  )
}

function RecentlyDeleted(props) {
  return (
    <ParentComponent>
      <RecentlyDeletedView {...props}/>
    </ParentComponent>
  )
}

function Preview(props) {
  return (
    <ParentComponent>
      <PreviewView {...props}/>
    </ParentComponent>
  )
}

function Settings(props) {
  return (
    <ParentComponent>
      <SettingsView {...props}/>
    </ParentComponent>
  )
}

export const routes = [
  {
    path: "/dashboard",
    exact: true,
    sidebar: renderSidebar(1),
    main: (initProps = {}) => {
      return (routeProps = {}) => (<Dashboard {...initProps} {...routeProps}/>);
    }
  },
  {
    path: "/folders/:folder_id/listing",
    exact: true, 
    sidebar: renderSidebar(1),
    main: (initProps = {}) => {
      return (routeProps = {}) => (<Dashboard {...initProps} {...routeProps}/>);
    }
  },
  {
    path: "/starred",
    exact: true,
    sidebar: renderSidebar(2),
    main: (initProps = {}) => {
      return (routeProps = {}) => (<Starred {...initProps} {...routeProps}/>)
    },
  },
  {
    path: "/preview",
    exact: true,
    sidebar: renderSidebar(-1),
    main: (initProps = {}) => {
      return (routeProps = {}) => (<Preview {...initProps} {...routeProps}/>)
    }
  },
  {
    path: "/settings",
    exact: true,
    sidebar: renderSidebar(3),
    main: (initProps = {}) => {
      return (routeProps = {}) => (<Settings {...initProps} {...routeProps}/>)
    }
  },
  {
    path: "/recently-deleted",
    exact: true,
    sidebar: renderSidebar(4),
    main: (initProps = {}) => {
      return (routeProps = {}) => (<RecentlyDeleted {...initProps} {...routeProps}/>)
    },
  },
  {
    path: "/search",
    exact: true,
    sidebar: renderSidebar(-1),
    main: (initProps = {}) => {
      return (routeProps = {}) => (<Search {...initProps} {...routeProps}/>)
    },
  }
];